import React from "react";
import { Modal } from "./Modal";

interface VideoPlayerModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: React.ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  showCloseButton?: boolean;
}

export const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  size = "md",
  className,
  header,
  footer,
  showCloseButton = true,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size={size}
      className={className}
      header={header}
      footer={footer}
      showCloseButton={showCloseButton}
    >
      {children}
    </Modal>
  );
};
